<template>
  <div class="product bps" v-bind:class="{contrasted: isPageContrasted, fontBigger: isFontBigger}">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" data-aos="fade-up" v-if="lang === 'pl'">Promocja marki produktowej BIOSECO</div>
        <div class="heading-text" data-aos="fade-up" v-if="lang !== 'pl'">Promotion of the Product Brand BIOSECO</div>
        <p data-aos="fade-up" data-aos-delay="100"></p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p data-aos="fade-up" data-aos-delay="200"></p>
      </div>
    </header>

    <div id="top" class="why-us-solution">
      <div class="elements">
        <div class="element bps clearfix">
          <div class="text-box">
            <ul v-if="lang === 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
                  Bioseco Spółka Akcyjna realizuje projekt pod tytułem:
                  „Promocja marki produktowej o znaczącym potencjale eksportowym - BPS- na zagranicznych targach i misjach gospodarczych szansą na wzmacnianie trwałego wzrostu i konkurencyjności Bioseco”
                  <br />
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                    Celem projektu jest promocja marki produktowej o znaczącym potencjale eksportowym – Bioseco Bird Protection System (BPS) – na zagranicznych targach i misjach gospodarczych w okresie 01.02.2024-31.12.2026.
                    Realizacja zadań zaplanowanych w projekcie umożliwi wzmocnienie konkurencyjności Bioseco na istniejących rynkach i wejście na nowe rynki Europy, Ameryki i świata.
                    <br />
                  </span>
                </li>
                <li>
                <span class="dot"></span>
                <span class="text">
                    Projekt współfinansowany jest z Europejskiego Funduszu Rozwoju Regionalnego w ramach programu: Fundusze Europejskie dla Nowoczesnej Gospodarki, <br/>
                    Priorytet: Środowisko sprzyjające innowacjom<br/>
                    Działanie: Promocja marki innowacyjnych MŚP<br/>
                    Umowa o dofinansowanie nr FENG.02.25-IP.02-0187/23
                    <br/><br/>
                  </span>
                </li>
              <li>
                <span class="text">
                  <br/>
                  Wartość projektu:<br/>
                  252 056.95 zł
                  <br/><br/>
                  Dofinansowanie projektu z UE:<br/>
                  126 028,48 zł
                </span>
              </li>
            </ul>
            <ul v-if="lang !== 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
                  Bioseco Spółka Akcyjna is implementing a project titled:
                  “Promotion of a Product Brand with Significant Export Potential - BPS - at International Trade Fairs and Economic Missions as an Opportunity to Strengthen Sustainable Growth and Competitiveness of Bioseco.”
                  <br />
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                  The aim of the project is to promote the product brand with significant export potential – Bioseco Bird Protection System (BPS) – at international trade fairs and economic missions during the period from February 1, 2024, to December 31, 2026.
                  The implementation of the tasks planned within the project will enhance Bioseco’s competitiveness in existing markets and facilitate entry into new markets in Europe, the Americas, and globally.
                    <br />
                  </span>
                </li>
                <li>
                <span class="dot"></span>
                <span class="text">
                  The project is co-financed by the European Regional Development Fund under the program: European Funds for a Modern Economy,<br/>
                  Priority: Innovation-Friendly Environment<br/>
                  Action: Promotion of Innovative SME Brands<br/>
                  Grant Agreement No. FENG.02.25-IP.02-0187/23
                    <br/><br/>
                  </span>
                </li>
              <li>
                <span class="text">
                  <br/>
                  Project value:<br/>
                  252 056.95 PLN
                  <br/><br/>
                  EU funding contribution:<br/>
                  126,028.48 PLN
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store/store';
import FooterMain from '../components/FooterMain';
import FooterMoreInformation from '../components/FooterMoreInformation';
import VideoBox from '../components/VideoBox';
import Counter from '../components/Counter';
import smoothScroll from '../helpers/SmoothScroll';

export default {
  name: 'farms-product',
  components: {
    FooterMain,
    FooterMoreInformation,
    VideoBox,
    Counter
  },
  data: function () {
    return {
      circleValues: [
        {
          before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
        },
        {
          before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
        },
        {
          before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
        },
        {
          before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
          val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
          after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
        },
      ]

    }
  },
  computed: {
    lang: () => {
      return store.state.lang;
    },
    isPageContrasted() {
      return store.state.isPageContrasted
    },
    isFontBigger() {
      return store.state.isPageFontBigger
    },
    smoothScroll: () => smoothScroll
  },

  methods: {},
  mounted: function () {
    store.state.isAccessibilityVisible = true;
  },
  destroyed: function () {
    store.state.isAccessibilityVisible = false;
  },
}
</script>

<style>
.bps header.page-header .heading-text {
  max-width: 1200px !important;
}

.product .why-us-solution .elements .element.bps .text-box {
  float: left;
  max-width: initial;
  margin-top: 20px;
  margin-bottom: 100px;
}

.product .why-us-solution .elements .element.bps .text-box ul li .text {
  margin-top: -20px;
}


.ue {
  position: fixed;
  bottom: 0px;
  left: 0;
  right: 0;
  text-align: center;
}

.ue img {
  max-width: 940px;
  width: 35%;
}

.product.contrasted {
  background: #000;
  color: yellow;
}

.product.contrasted .heading-text {
  color: yellow;
}

.product.contrasted .ue {
  background: #000;
}

.product.contrasted header a {
  color: yellow;
  background: #000;
}

.product.contrasted .btn {
  color: yellow;
  background: #000;
}

.product.fontBigger .why-us-solution .elements .element .text-box ul li .text {
  font-size: 1.6em;
  line-height: 1.6em;
}


</style>



// WEBPACK FOOTER //
// PPBB.vue?6a6564b0